import { useMemo } from 'react';

import { PureSwitch } from '@/components/form/Switch'
import { useGrid } from '@Components/Grid'
import { NameAndCreateDateFormatter, HeaderRPUImpresisonsFormatter, RPUFormatter, EnabledBadgeFormatter, keyOf } from '@Components/Grid/components/Table/formatters'
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, duplicateWithNameAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';
import { useSelectOptions } from '@Stores/base-factories/store-list'

import CustomFieldFormatter from './CustomFieldFormatter'
import DetailsFormatter from './DetailsFormatter';
import MultiBuyerFormatter from './MultiBuyerFormatter';
import ReportLink from './ReportLink';
import RulesFormatter from './RulesFormatter';

export default function useColumns() {
  const { store: { lists: { customFields: { items, useLoad } } } } = useGrid()
  const customFields = useSelectOptions({ items, useLoad })

  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { initialSize: 'max-w-[20vw]' }),
    column.accessor('type', {
      header: 'Type',
      cell: info => <DetailsFormatter info={info} />,
      initialSize: 'max-w-[20vw]',
    }),
    column.accessor('integrationDataParsed', {
      header: 'Custom Field',
      cell: info => <CustomFieldFormatter info={info} customFields={customFields} />,
      defaultVisible: false,
      enableSorting: false,
      initialSize: 'max-w-[15vw]',
    }),
    column.accessor('hideHostedSubmit', {
      header: 'Hide Hosted Submit',
      cell: info => <EnabledBadgeFormatter info={info} />,
      defaultVisible: false,
      enableColumnResize: false,
    }),
    column.accessor('dynamicNavigation', {
      header: 'Dynamic Navigation',
      cell: info => <EnabledBadgeFormatter info={info} />,
      defaultVisible: false,
      enableColumnResize: false,
    }),
    column.accessor('integrationDataParsed.sanitary', {
      header: 'Override content',
      cell: info => <PureSwitch value={!!info.getValue()} disabled />,
      defaultVisible: false,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('impressions', {
      header: () => <HeaderRPUImpresisonsFormatter title='Impressions' />,
      cell: info => info.getValue() || 0,
      enableSorting: false,
    }),
    column.accessor('rpu', {
      header: () => <HeaderRPUImpresisonsFormatter title='RPU' />,
      cell: info => <RPUFormatter info={info} />,
      enableSorting: false,
    }),
    column.accessor('multiBuyer', {
      header: 'Multi Buyer',
      cell: info => <MultiBuyerFormatter info={info} />,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('rules', {
      header: 'Rules',
      cell: info => <RulesFormatter info={info} />,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateWithNameAction, reportLinkAction),
  ], [customFields])
}

function reportLinkAction(info) {
  return <ReportLink key={keyOf(info, 'report-link')} info={info} />
}
